import { useState, useEffect } from 'react';

export function useScreenSize() {
    const [isLarge, setIsLarge] = useState(window.innerWidth >= 1024);
    const [isTablet, setIsTablet] = useState(window.innerWidth >= 768 && window.innerWidth < 1024);

    useEffect(() => {
        const handleResize = () => {
            const width = window.innerWidth;
            setIsLarge(width >= 1024);
            setIsTablet(width >= 768 && width < 1024);
        };

        window.addEventListener('resize', handleResize);
        handleResize();

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return { 
        isLarge,    // Corresponds to lg:
        isTablet,   // Corresponds to md:
        isMobile: !isLarge && !isTablet 
    };
}